import {Card, Col, Row} from "react-bootstrap";
import MeasurementText from "../MeasurementText/MeasurementText";
import React from "react";
import Arrow from "../Arrow/Arrow";
import {getMonthLabel} from "../Utils/utils";

export default function TotalWaterConsumption(props) {
    const waterConsumptionData = props.data.waterConsumption;
    const totalWaterConsumption = waterConsumptionData.current;
    const previousMonthLabel = getMonthLabel(waterConsumptionData.increaseDate);
    const lastMonthValue = waterConsumptionData.lastMonthValue;
    const lastMonthLabel = getMonthLabel(waterConsumptionData.lastMonthDate);
    const compareValue = waterConsumptionData.increaseValue;
    const lastNDays = props.data.nLastDays;
    const volumeUnit = props.volumeUnit;
    const isPositive = compareValue > 0;
    const positiveComparedValue = isPositive ? compareValue : compareValue * -1;

    return (
        <Card style={{height: '272px'}}>
            <Card.Body>
                <Card.Title className={'bold-title'}>Total Water Consumption</Card.Title>
                <Card.Subtitle className={'text-muted'}>Last {lastNDays} Days</Card.Subtitle>
                <Card.Text style={{marginTop: '18px'}}>
                    <MeasurementText value={totalWaterConsumption} unit={volumeUnit}/>
                </Card.Text>
                <hr/>
                <Card.Text>
                    <Row style={{marginTop: '18px'}}>
                        <Col md={4}>
                            <Card.Subtitle className={'text-muted'}>{lastMonthLabel}</Card.Subtitle>
                        </Col>
                        <Col md={8}>
                            <Card.Subtitle className={'text-muted'}>Compared to {previousMonthLabel}</Card.Subtitle>
                        </Col>
                    </Row>
                </Card.Text>
                <Card.Text>
                    <Row style={{marginTop: '4px'}}>
                        <Col md={7}>
                            <MeasurementText value={lastMonthValue} unit={volumeUnit}/>
                        </Col>
                        <Col md={5} className={'compared-value'}>
                            <Row>
                                <Col md={5}>
                                    <Card.Text>
                                        <Arrow isPositive={isPositive}/>
                                    </Card.Text>
                                </Col>
                                <Col md={8} className={'arrow-value'}>
                                    <Card.Text style={{textAlign: 'center'}}>{positiveComparedValue || 0}%</Card.Text>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Card.Text>
            </Card.Body>
        </Card>
    )
}